module.exports = __webpack_public_path__ + "media/images/common/menu-8d1503b4f0b1046f3e3a51099dfb034e.png";